import React from "react";
import clientConfigApi from '../config/config'

export const getAllAvailableEvents = async () => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    let payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo? currentUserInfo[0].reservationNumber : undefined,
            "guestToken": currentUserInfo?  currentUserInfo[0].guestToken : undefined,

        },
        "payload": {
        }
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getAllEvents`, payload)
        return data
    } catch (error) {
        return error
    }

}


export const getMyEventsReservations = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))


    let payload_ = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo? currentUserInfo[0].reservationNumber : undefined,
            "guestToken": currentUserInfo?  currentUserInfo[0].guestToken : undefined,


        },
        payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getAllReservations`, payload_)
        return data
    } catch (error) {
        return error
    }

}


export const getAvailableDateTime = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))


    let payload_ = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo? currentUserInfo[0].reservationNumber : undefined,
            "guestToken": currentUserInfo?  currentUserInfo[0].guestToken : undefined,


        },
        payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/getVenueAvailability`, payload_)
        return data
    } catch (error) {
        return error
    }

}

export const bookEvent = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))


    let payload_ = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo? currentUserInfo[0].reservationNumber : undefined,
            "guestToken": currentUserInfo?  currentUserInfo[0].guestToken : undefined,


        },
        payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/bookEvent`, payload_)
        return data
    } catch (error) {
        return error
    }

}

export const cancelEvent = async (payload) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    
    let payload_ = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo? currentUserInfo[0].reservationNumber : undefined,
            "guestToken": currentUserInfo?  currentUserInfo[0].guestToken : undefined,



        },
        payload
    }

    try {
        let data = await clientConfigApi.post(`/restaurantTableBooking/cancelReservation`, payload_)
        return data
    } catch (error) {
        return error
    }

}

